module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter Two")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Alex swallowed so hard she could see his throat work. His eyes narrowed dangerously. Their stares stretched on and on until Liz finally sat down on the ottoman. “I don’t understand. You confessed. Now you’re telling me you didn’t murder my uncle?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I didn’t murder your uncle.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But you thought I did?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, I did,” he said, and closed his eyes. She could only imagine what he was thinking and feeling.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I went to tell Devon he could give his blasted money to a flea circus for all I cared,” he added, opening his eyes and searching her face. “I wanted him to leave us alone. Don’t you think I know how hard it’s been for you to keep peace with him, to do things his way, how impossible it’s been? But telling you to divorce me, to ‘get rid’ of our baby if you ever wanted to see a dime of his money—when he said those things, he burned his bridges as far as I was concerned and I wanted him to know it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He was in the den, crumpled on the floor in front of his desk, your scarf tangled in his fingers. He was warm. My EMT training kicked in and I felt for a pulse, I thought maybe—but he was already dead.”")])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh, Alex.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And then Sheriff Kapp showed up. He’d received a telephone tip that something was going down at Devon Hiller’s house. He asked me to come in with him, to answer questions. I still wasn’t saying much of anything, just that I’d found Devon like that but I had his blood on my sleeve and apparently I even touched the handle of the letter opener because they found my prints on it. The sheriff started insinuating things about you and all I could think about was the murder scene. I’d found the scarf but had I missed something else you left? I confessed there’d been a struggle and he’d fallen. The sheriff was anxious to wrap it all up in record time and he was absolutely sure he had his man.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You wouldn’t let me help you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I wanted the investigation to begin and end with me. I thought you would understand what I was doing, why I "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("had")]), _vm._v(" to do it. Your silence confirmed you did.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“My silence?” Liz said, angry now. “What choice did you give me but silence?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He shook his head again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You didn’t give me a chance to explain.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Explain what? How mad you were? How mad we both were? You and I were prime suspects. Everyone at the house that night heard you threaten your uncle, heard you tell him you’d had enough, that you weren’t going to take it anymore.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I meant I was going to quit my job and stop subjecting myself to his manipulations.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Dozens of bystanders only heard a threat. You were pregnant. You’d had a miscarriage a few months before and I couldn’t let anything happen to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So you told them you did it.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("“For once, my family history came in handy. Nobody ")]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("ever really expected a Chase man to stay out of trouble for long. I don’t think it strained anyone’s imagination to picture me as a killer. Logic said it had to be one of us.”")])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But, Alex, it wasn’t one of us.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He stared at her. “No, it wasn’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Liz felt her heart thump wildly. Alex reached out and took her hand, kissed her palm, and folded her hand in his. His fingers flicked over her bare finger, absent of her thick gold wedding band. “No,” he repeated, “it wasn’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re innocent.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So are you.” His relief was palpable and for the first time she understood the depth of the burden he’d been carrying. He’d thought she’d killed her uncle, he knew he hadn’t. He’d given up his freedom and his chance to know his child—all for her. He’d thought she’d been willing to repay this sacrifice by leaving him to suffer the consequences alone. And then she’d asked him for a divorce.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She felt herself lean toward him, she felt him leaning toward her. What came now, a kiss, reconciliation, everything back to the way it was? She pulled away.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His eyes demanded an explanation but she didn’t have one to offer. What he’d done was protect her and she felt humbled. But he hadn’t trusted her. She’d thought they were a team, but Alex hadn’t included her in a decision that would forever change the course of both of their lives—and that of their unborn child. Quite the opposite, he’d gone out of his way to exclude her.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("His distrust of the sheriff was old news. It reminded her that Alex had learned, within the boundaries of his highly dysfunctional family, to go it alone. A stint in the army and the years at the fire station had tempered his ")]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("fierce independent streak so that he’d become comfortable working as part of a team with men he respected. She’d assumed that quality would extend into their marriage, but he’d jumped to a terrible and wrong conclusion this time and he hadn’t trusted her when it counted.")])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("That hurt.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("More to the heart of the matter, he’d also implicated himself so thoroughly that it might never be made right because Alex was correct—the whole community had reacted to his arrest with a knowing shake of their collective head.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Another Chase man gone wrong.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Only this one hadn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Alex stood, and extending a hand, helped Liz to her feet. “Are you okay now?” he asked softly. “Is the baby all right?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We’re both fine.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You must know I love you—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("This time she held up a hand to silence him. Her feelings were like tumbleweeds, roaming here and there and everywhere, rootless and brittle. “I can’t talk anymore tonight,” she mumbled.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re exhausted,” he said, his voice filled with concern. Taking her hand, he looked at her with eyes so deep and midnight blue she yearned to get lost in them the way she had in the past, lost and found at the same time. He whispered, “You go to bed.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What about you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He glanced around the room then back at her. “I need to think.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("She felt a consuming shudder rack her body from the inside out and knew she needed time alone to absorb all this startling new information. For six months she’d thought him a murderer. And worse in some ways, she’d ")]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_vm._v("thought he had stopped loving her, stopped needing her. These feelings had never seemed, well, right, but for six months, she’d told herself that her feelings, especially when it came to Alex, were unreliable. All that didn’t change in an instant.")])]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She picked up Sinbad who immediately started purring. Lowering her gaze, avoiding Alex’s eyes, she said, “When you do get tired, I think it would be best if you slept in the guest room.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She could feel him staring at her pregnancy as though he was wondering if she just wanted the bed to herself for comfort’s sake or because she didn’t want him that close. She added, “There’s a sleeping bag in the closet. All your clothes are packed away in the attic.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Don’t worry about me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was so much she wanted to say to him. She didn’t know where to start.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He moved to her side, cupped her chin and kissed her. She closed her eyes and concentrated on the moist warmth of his lips, on the undercurrent of desire she could feel pulse between them. It was all she could do to keep from asking him to join her, to hold her, to make love to her, to take away some of the pain they had unwittingly caused each other.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But she didn’t. The world had exploded tonight—again. Alex was afraid a new investigation would lead the law to her. She was more afraid that he would once again try to protect her by offering himself up like a sacrificial goat. She didn’t want him spending the rest of his life in prison for a crime he didn’t commit.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_vm._v("After all, it was just his word that he was innocent, just her word that she was, too. As far as she knew, the only pieces of undiscovered evidence both led back to ")]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_vm._v("her: the silk scarf and her late-night visit, the one she’d thought no one knew about.")])]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Most likely, other than the true killer, she was the last one to see Uncle Devon alive.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And that wasn’t exactly a comforting thought, either.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("L"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("IZ WAS INNOCENT")]), _vm._v(". "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("He should have known.")]), _vm._v(" She was innocent. Not self-defense, not an accident—innocent.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Of course, the flip side of that was that there was a murderer on the loose. Even worse, there was a murderer on the loose who must have thought they were all but home free. What would happen when that person learned about the hung jury and the new investigation?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Liz’s green scarf worried him. How had her uncle ended up with that piece of sand-washed silk wrapped around his fingers? Alex realized he should have asked Liz more about it and he stopped pacing long enough to glance down the hall and consider going to her room right now.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The thought of her snuggled in the bed they’d shared so many times stopped him. There was no way in the world he would be able to leave her side once he was there. Pregnant or not, she was the most sensual woman he’d ever known and he ached for her in his mind, in his body, in his soul.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He needed her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The dark smudges under her eyes also kept him where he was. It was obvious that the past six months had been as harrowing for her as it had been for him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eventually, he made his way down the hall, too drained to put together a coherent thought. The surprise came when he discovered the spare room, so much bigger than his former cell, felt like a prison nonetheless.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_vm._v("For one thing, everything was all changed around. ")]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_vm._v("Gone was the twin bed, the dresser and chairs, the wooden desk he’d brought from his apartment when they married. Instead, there was a navy colored futon against one wall and a glass desk topped with a high-tech computer on the other.")])]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Liz was good with computers. He thought them a giant waste of time better spent outdoors. And how he had missed the outdoors. Even the short, cool walk from Dave’s truck to Liz’s door with the tangy taste of the sea on his tongue, the crunch of gravel and redwood fronds under his feet, the roar of the ocean below and the boughs whipping in the wind above had been seconds of pure bliss. Freedom. Wonderful, messy, beautiful freedom.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He stripped down to his shorts and crawled into the sleeping bag. The flannel felt good against his skin, comforting somehow, reminding him of all the camping trips he’d taken with Liz, of the fireside romance that had taken place once they zipped their bags together and made love beneath the stars.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He heard the creak of her bedsprings and wondered if she was as wide-awake as he. The wall was just too damn thin.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Getting dressed again, he abandoned the sleeping bag and retreated to the living room but found little comfort. Memories were everywhere he looked. As lonely as his cell had been, what had it been like for Liz to be caught here in an old house full of ghostly reminders?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("What in the world was he going to do?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Find the killer, make him or her pay, that’s what he was going to do.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_vm._v("Over and over again, he recalled the night he and Liz had driven to her uncle’s house. Devon Hiller had been hosting a party celebrating the twentieth anniversary of ")]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_vm._v("his pride and joy, the Harbor Lights Mall. There had been scads of people present. He and Liz had told Devon about the baby in private, but the ensuing explosion had spilled out of the study and into the house. Everyone had heard everything that was said.")])]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sure, he’d wanted to strike Devon Hiller dead in his tracks. How could he not when Devon’s cruel tongue lashed out at the woman he loved? But as Liz fought back, probably for the first time in her life, Alex had stood there, rigid with fury, afraid that if he acted he wouldn’t be able to contain himself. When he’d finally looked at Liz he’d been stunned by the expression on her face. It was as though she saw the old man for who he really was, or at least finally understood it. He couldn’t wait to get her out of there.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And later, when he’d found Hiller’s body, he’d assumed this insight had given his gentle wife the courage to return for a final, private confrontation that had led ultimately to the need to protect herself and her baby.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Restless, Alex roamed the house. He looked at the Homer print of a breaching sailboat on the wall, at the books stacked two deep on the shelves, at the catnip mouse abandoned near Sinbad’s water bowl, and once again vowed never to return to prison.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Unless he had to protect Liz.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Who had hated Devon Hiller enough to kill him? Hell, who hadn’t? No, that wasn’t true. People often hated other people, but not to the point of killing them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Okay, who kills a man so old and riddled with self-inflicted health problems that he was due to self-destruct within a year anyway? Why take the chance? Why not just wait until the old guy dies of natural causes? According to his will, the only one who stood to benefit from his death was Liz.")])]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Alex watched the sky grow gradually lighter while standing out in back near the bluff. The cold wind of the night before had given way to a light rain which felt great. Cold, wet, great. Seagulls wheeled overhead and the wooden stairs leading down the hillside to the beach below disappeared in swirling mists. Waves crashed against the shore, retreating with a loud swish. A few hours from now, at high tide, there would be no beach, just the relentless surf beating against the huge rocks at the base of the cliff.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Liz had been orphaned days before her eighth birthday when a fire burned her family’s home to the ground. Only the fact that Liz was staying at a friend’s house had spared her. Her uncle had taken her in, but as soon as she turned twenty-one and inherited her parents’ money, she’d bought this place and moved out on her own. Alex imagined that streak of autonomy had irritated the hell out of her uncle but he shouldn’t have worried. Liz might have moved ten miles north, but for years after, she’d still worked hard to please the man who had raised her, managing his biggest mall, sweeping up after him when he alienated his employees.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Slowly, Liz was fixing the house up, making it into a home, and though he worried about her spending so much time out here alone, he couldn’t deny that there was something very life affirming about living in one of nature’s more spectacular pockets. Last spring, they’d talked about building a fenced backyard before the baby came. He made a mental note to start it now.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A movement in the house caught his eye. He turned to see that Liz had come to the glass door and was staring at him, a yellow towel in one hand.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_vm._v("He was still getting used to her ballooned figure. When last he’d seen her, she’d been angular on the out")]), _c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_vm._v("side and soft in the middle. Now she was just the opposite. It made him feel awful that he was responsible for the guarded edge he detected in her.")])]), _c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He had to find out what she remembered about her scarf. If she hadn’t left it in her uncle’s den, then someone else had taken it there and that someone must have wanted to implicate Liz.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As he crossed the wet ground, he saw her move away from the door, leaving the towel draped over the back of a kitchen chair. He left his wet shoes and the raincoat under the overhang, went inside and dried his short hair as she took a carton of eggs out of the refrigerator. Sinbad, twining his way around her legs, meowed in that strident Siamese cry that always reminded Alex of a small baby.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Did you sleep okay?” she asked, turning to look at him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Fine. You?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Fine.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You look great,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She glanced down at her maternity clothes and protruding belly and smiled wistfully. “Oh, yeah, I’m a real treat. That isn’t your shirt, is it? Or your jacket?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Dave brought me some of his brother’s stuff. Liz, what do you remember about your green scarf?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She popped slices of bread in the toaster. “Move, Sinbad,” she scolded the cat who squeezed his eyes at her and stood his ground. She faced Alex with a troubled expression. “I don’t know. I thought about that last night after I went to bed. When had I worn it last, where had I last seen it? But I can’t remember. It just seems that I had it and then I didn’t have it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He picked up the cat and rubbed his sable ears. “What about at the party?”")])]), _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t know. It’s been so long ago and so much has happened, I don’t remember what I was wearing that night. I do recall that we hadn’t changed clothes after work or dressed up or anything. It’s important, isn’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Very. And you were wearing a greenish-blue dress.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She looked thoughtful, then shook her head again. “I know the dress, I used to wear it with your scarf, but I don’t remember if I did that night or not. It’s no use.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’ll come to you,” he said with confidence, desperate to ease the strain on her face. He put Sinbad down on an empty chair and added, “I notice you have a big old computer in the guest room now. You know how hopeless I am on those things. But maybe you can use it to help us figure out who really killed your uncle.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She bit her lip. “I was thinking. Maybe you should go to Sheriff Kapp or the D.A. and explain this…misunderstanding.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She was dressed in a pale-blue cotton blouse and loose white sweater, clothes that did nothing to add color to her washed-out complexion. Was she beautiful? Of course, but her beauty was accidental now. With an incredulous tone to her voice, she said, “What do you mean, ‘No’?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Think about it. A brand-new story, a retraction of my confession, they’ll all just think I’m grasping at straws. Worse, the information that you were at your uncle’s house later that night to say nothing of the fact that a piece of your clothing was found in his hand will put you under scrutiny, and maybe not just for second degree murder like me. Your scarf might be interpreted as a would-be weapon that suggests premeditation, they might go after the death penalty. Absolutely no way we’re ever going to chance it.”")])]), _c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ve been thinking, too. I need to figure out who killed your uncle and how to prove it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re not an investigator. We’ll hire a really good lawyer—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t want your name coming into any of this until I know who’s responsible.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She jerked open the refrigerator and emerged with the orange juice. He set out small glasses and watched as she poured the juice. “That’s very noble, but I repeat, you’re not an investigator.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Taking the juice to the table, he called over his shoulder. “That baby you’re carrying is mine, Liz.” He moved to her side and gently touched her tummy, praying she wouldn’t flinch like she had the night before. When she didn’t, he left his hand where it was. “I want his or her name to be one he or she will be proud to own. Now that I know you’re innocent, I won’t rest until I clear that name. That’s a promise.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She stared into his eyes and said, “Can you feel it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He hadn’t the slightest idea what she was talking about. “Feel what?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She put her hand over his and pressed down a little. “Right here. The baby. Kicking up a storm.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And suddenly he felt a muffled thump against his palm. “Yes,” he said, grinning. “Yes.” He felt several more soft kicks and then it seemed as though Liz’s whole belly kind of shifted to the side.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You just experienced a rollover,” Liz said. “Trust me, it’s quite a sensation from the inside.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I bet it is,” he said, longing to lift her blouse and lay his cheek against her stomach. Instead he reluctantly dropped his hand.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_vm._v("“You have to get over worrying about implicating ")]), _c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_vm._v("me, Alex,” she said as she set their plates on the table. “We have to tell—”")])]), _c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No,” he repeated, and sat down opposite her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You still don’t trust anyone, do you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I trust you,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But you didn’t trust me when it mattered. You didn’t give the law a chance. You still won’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You mean that idiot, Kapp.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Roger Kapp isn’t so bad.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He’s a dangerous fool. Maybe my poor opinion of him stems from the fact that he was out at my house a lot as I grew up, hassling my brothers. He was a deputy then and liked to throw his weight around. Or maybe it’s the way he used you to get to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Try to put the past behind you. Let’s just talk to him—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Look, it’s my hide we’re talking about. And I’m the one who fouled things up. Now, eat something. You need to keep your strength up.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("For the first time since she’d opened the door the night before, she really smiled. Alex drank in the sight—to him more breathtaking than any sunrise—and hoped he’d find a way to make it happen again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Tonight we share the same bed,” he said softly, admiring the lovely curve of her jaw. This new clarity of her features was one of the surprising bonuses of her shorter hair. He could see the long, graceful line of her neck, her sweet earlobes, her golden eyebrows. “I don’t know the rules about sex and pregnancy, but surely being held in a husband’s arms is on the approved list,” he added tenderly.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_vm._v("The smiled faded and she grew increasingly silent. He tried concentrating on the taste of fresh eggs and icy juice. He tried living in the moment, relishing the sounds ")]), _c('a', {
    attrs: {
      "id": "page39"
    }
  }, [_vm._v("of the soft rain on the roof, the hum of the refrigerator, the distant thunder of waves. The very fact that he was back in the middle of his own life, seated at his own table, looking at his own wife, was astounding and cause for profound thankfulness. He tried to ignore the black cloud he could feel hovering over them both.")])]), _c('a', {
    attrs: {
      "id": "page39"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Nothing worked. Liz fed Sinbad bits of egg which he seemed to demand with strident yowls. She folded and refolded her napkin, moved her juice glass from one side of the placemat to the other.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Remember when you found out you were pregnant?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("That got her attention. She said, “Yes. Of course.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You put on that tight red dress with the low, sexy back and bought a bottle of sparkling apple cider. You even soaked off the cider label and replaced it with a champagne label, remember? You made sure we had the evening alone, made a platter of fancy little things to eat, sat me down, mumbled something I couldn’t understand and then started fidgeting. In fact, before you finally got the news out, you did everything but reline the kitchen shelves.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She smiled at the memory. “Well, I was nervous.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I know. And now you’re at it again.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She stopped folding her napkin into triangles and looked up at him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Besides everything, Liz, what’s troubling you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Nothing.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He put his hand over hers. “I’m not an idiot. Come on, fess up, what’s wrong?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She cast him a wary glance and bit her top lip. “I just keep thinking about how you must have hated me.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page39"
    }
  }, [_vm._v("There was nothing in the world she could have said ")]), _c('a', {
    attrs: {
      "id": "page40"
    }
  }, [_vm._v("that would have astonished him more. “What are you talking about?”")])]), _c('a', {
    attrs: {
      "id": "page40"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Brushing wayward strands of pale hair from her forehead, she said, “You thought I killed Uncle Devon and then sat by while you took the blame for it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No, no, honey. I thought you understood that I understood—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You thought I was more worried about myself than I was about you. It makes me feel terrible that you could have thought that of me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He shook his head, unsure what to say. Why hadn’t it occurred to him that his delicate wife would no more stand aside and let him take the blame for something she did than fly to the moon?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m sorry.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Laying her fork aside, gaze averted, she added, “You didn’t turn to me when it mattered most. You pushed me and our marriage aside and went it alone. I…I feel as though I can’t trust you anymore. I don’t want you behind bars for something you didn’t do, for trying to protect me, but beyond that I…I don’t know. About us, I mean. About our future. I’m sorry.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You don’t mean that,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A single tear rolled down her cheek as she averted her gaze.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She meant it.")])])]), _c('a', {
    attrs: {
      "id": "page40"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page40"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b294d710","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781459237445_ch02.vue
// module id = 90
// module chunks = 0